module.exports = __webpack_public_path__ + "static/brandhero-logo-903f1ecf7417c002974ce1c82ebd530f.jpeg";